import React, { memo } from 'react'
import { Box, Text, Stat, StatLabel, StatNumber, StatHelpText, Flex, Icon, Skeleton } from '@chakra-ui/react'
import { FiCheck, FiAlertTriangle } from 'react-icons/fi'

export const StatusCard = memo(({ totalAtualizado, totalDesatualizado, isLoading }) => {
  const total = totalAtualizado + totalDesatualizado
  const percentualAtualizado = total > 0 ? Math.round((totalAtualizado / total) * 100) : 0

  if (isLoading) {
    return (
      <Box bg="white" borderRadius="md" boxShadow="sm" p={4} mb={4}>
        <Skeleton height="100px" />
      </Box>
    )
  }

  return (
    <Flex justify="space-between" gap={4} mb={4}>
      <Box flex="1" bg="white" p={4} borderRadius="md" boxShadow="sm" borderLeft="4px solid" borderLeftColor="green.400">
        <Stat>
          <Flex justify="space-between" align="center">
            <StatLabel color="gray.600">Produtos Atualizados</StatLabel>
            <Box bg="green.100" p={2} borderRadius="full">
              <Icon as={FiCheck} color="green.500" />
            </Box>
          </Flex>
          <StatNumber fontSize="2xl">{totalAtualizado}</StatNumber>
          <StatHelpText mb={0}>{percentualAtualizado}% do total</StatHelpText>
        </Stat>
      </Box>

      <Box flex="1" bg="white" p={4} borderRadius="md" boxShadow="sm" borderLeft="4px solid" borderLeftColor="orange.400">
        <Stat>
          <Flex justify="space-between" align="center">
            <StatLabel color="gray.600">Produtos Desatualizados</StatLabel>
            <Box bg="orange.100" p={2} borderRadius="full">
              <Icon as={FiAlertTriangle} color="orange.500" />
            </Box>
          </Flex>
          <StatNumber fontSize="2xl">{totalDesatualizado}</StatNumber>
          <StatHelpText mb={0}>{100 - percentualAtualizado}% do total</StatHelpText>
        </Stat>
      </Box>

      <Box flex="1" bg="white" p={4} borderRadius="md" boxShadow="sm" borderLeft="4px solid" borderLeftColor="blue.400">
        <Stat>
          <Flex justify="space-between" align="center">
            <StatLabel color="gray.600">Total de Produtos</StatLabel>
            <Box bg="blue.100" p={2} borderRadius="full">
              <Text fontWeight="bold" color="blue.500">
                {total}
              </Text>
            </Box>
          </Flex>
          <StatNumber fontSize="2xl">{total}</StatNumber>
          <StatHelpText mb={0}>Catálogo completo de Fornecedores</StatHelpText>
        </Stat>
      </Box>
    </Flex>
  )
})

StatusCard.displayName = 'StatusCard'
